export const isInteger = (value: number | string) => /^\d+$/.test(`${value}`);

export const isNumber = (value: number | string): boolean =>
    /^\d+([.,]\d+)?$/.test(`${value}`);

export const isTypingNumber = (value: number | string): boolean =>
    /^\d*([.,]\d*)?$/.test(`${value}`);

export const hasLimitDecimals = (
    value: number | string,
    maxDecimal: number
): boolean => {
    const regex = new RegExp(`^\\d+([.,]\\d{0,${maxDecimal}})?$`);
    return regex.test(String(value));
};